import { z } from 'zod';

/** Variáveis expostas ao bundle: apenas VITE_API_URL (nada sensível). */
const envSchema = z.object({
  VITE_API_URL: z
    .string()
    .regex(/^(\/|https?:\/\/)/, 'VITE_API_URL deve ser caminho (/api) ou URL http(s)')
    .default('/api'),
});

/** Configuração validada do SPA. */
export const env = envSchema.parse(import.meta.env);
